import { useState } from 'react';
import * as api from '../../api/analytics';

export default function SOQLEditorModal({ viewId, onClose, onSave }) {
  const [soqlText, setSoqlText] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  const handleSave = async () => {
    if (!soqlText.trim()) {
      setError('SOQL query cannot be empty.');
      return;
    }
    setSaving(true);
    setError(null);
    try {
      await api.updateView(viewId, { sheet_mode: 'data', soql_content: soqlText });
      onSave();
    } catch (err) {
      setError(err.message || 'Failed to save query.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50" data-testid="soql-editor-modal">
      <div className="bg-white rounded-lg shadow-xl p-6 w-[560px] flex flex-col gap-4">
        <div className="flex items-center justify-between">
          <h2 className="text-lg font-semibold">Add SOQL Query</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-xl" data-testid="soql-modal-close">&times;</button>
        </div>
        <p className="text-sm text-gray-500">
          Enter a SOQL query to convert this free sheet into a data-mode view. This will populate the sheet with data from your CRM.
        </p>
        <textarea
          className="w-full h-48 border rounded px-3 py-2 text-sm font-mono resize-none focus:outline-none focus:ring-2 focus:ring-purple-300"
          placeholder="SELECT Id, Name FROM Account LIMIT 100"
          value={soqlText}
          onChange={e => setSoqlText(e.target.value)}
          data-testid="soql-editor-input"
          disabled={saving}
        />
        {error && (
          <div className="text-sm text-red-600 bg-red-50 border border-red-200 rounded px-3 py-2" data-testid="soql-editor-error">
            {error}
          </div>
        )}
        <div className="flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-3 py-1 border rounded text-sm text-gray-700 hover:bg-gray-50"
            data-testid="soql-modal-cancel"
            disabled={saving}
          >
            Cancel
          </button>
          <button
            onClick={handleSave}
            className="px-3 py-1 bg-purple-600 text-white rounded text-sm hover:bg-purple-700 disabled:opacity-50"
            data-testid="soql-modal-save"
            disabled={saving || !soqlText.trim()}
          >
            {saving ? 'Saving…' : 'Save & Load Data'}
          </button>
        </div>
      </div>
    </div>
  );
}
